import gql from 'graphql-tag'

export const LIST = gql`
  query {
    patients @rest(type: "[Patient]", path: "/share/doctor/?{args}") {
      id
      login
      registerDate
      createdAt
      name
      cpf
      birthDate
      gender
      thumbnail
      cellphone
      tokenNotification
      verifiedPhone
      notificationEnable
      user
      orientation
      bloodType
      rhFactor
      alimentation
      smoke
      drug
      alcohol
      physicalActivity
      ethnicity
      favoriteDoctors
      estabelishmentPatient
      allergies
      familyHistory
      continuousMedications
      totalSize
      imageSize
      docsSsize
      videoSize
      othersSize
      healthInsuranceSubPlan
      healthInsurance
      healthInsuranceNumber
      healthInsuranceCardPhoto
    }
  }
`

export const GET = gql`
  query ($id: Int) {
    patient(id: $id) @rest(type: "Patient", path: "/patient?{args}") {
      id
      login
      registerDate
      createdAt
      name
      cpf
      birthDate
      gender
      thumbnail
      cellphone
      tokenNotification
      verifiedPhone
      notificationEnable
      user
      orientation
      bloodType
      rhFactor
      alimentation
      smoke
      drug
      alcohol
      physicalActivity
      ethnicity
      favoriteDoctors
      estabelishmentPatient
      allergies
      familyHistory
      continuousMedications
      totalSize
      imageSize
      docsSsize
      videoSize
      othersSize
      healthInsuranceSubPlan
      healthInsurance
      healthInsuranceNumber
    }
  }
`

export const LIST_OBSERVATIONS = gql`
  query ($id: Int) {
    patient(id: $id) @rest(type: "Patient", path: "/patient?{args}") {
      id
      name
    }
    observations(patient: $id) @rest(type: "Observation", path: "/patientObservation?{args}") {
      id
      title
      description
      createdAt
      doctorPatient
    }
  }
`

export const LIST_EXAMS = gql`
  query ($id: Int) {
    patient(id: $id) @rest(type: "Patient", path: "/patient?{args}") {
      id
      name
    }
    folder(patient: $id) @rest(type: "Folder", path: "/timeline?{args}") {

      results

      # results @type(name: "ResultsFolder") {

      #   folder @type(name: "MetaFolder") {
      #     canCreateExamWithoutChronology
      #     canCreateFolder
      #     default
      #     deleted
      #     id
      #     name
      #     numberOfExams
      #     parent
      #     parentId
      #     parentName
      #     path
      #     user
      #   }
      #   folders @type(name: "SubFolder") {
      #     id
      #     numberOfExams
      #     name
      #   }
      #   exams @type(name: "Exam") {
      #     id
      #     name
      #     createdAt
      #     createdByPatient
      #     deleted
      #     description
      #     establishment
      #     examDate
      #     folder
      #     formatedDate
      #     idSync
      #     medias
      #     name
      #     patient
      #   }


      # }


    }
  }
`

export const FAVORITE = gql`
  mutation ($input: Favorite!) {
    favorite(input: $input) @rest(type: "Favorite", path: "/favorite/doctor/", method: "POST", bodySerializer: "form") {
      NoResponse
    }
  }
`

export const UPDATE = gql`
  mutation ($input: Observation!) {
    media(input: $input) @rest(type: "Observation", path: "/patientObservation/", method: "PUT", bodySerializer: "form") {
      NoResponse
    }
  }
`

export const CREATE = gql`
  mutation ($input: Observation!) {
    media(input: $input) @rest(type: "Observation", path: "/patientObservation/", method: "POST", bodySerializer: "form") {
      NoResponse
    }
  }
`
